const getDefaultState = () => ({
  userExtensionCount: 0,
  extensionType: '',
  extensionModal: false,
  userExtensions: [],
  extension: {},
  ilmdCount: 0,
  ilmd: [],
  parentIlmd: {},
  errorExtensions: [],
  errorParentExtension: {},
  errorExtensionCount: 0,
  currentExtensionInfo: null,
  currentExtensionId: null,
  parentExtension: null
})

export default {
  namespaced: true,

  state: getDefaultState,

  mutations: {
    resetExtensionsData(state) {
      Object.assign(state, getDefaultState())
    },
    extensionTypePopulator(state, extensionType) {
      state.extensionType = extensionType
    },
    showExtensionModal(state) {
      state.extensionModal = true
    },
    hideExtensionModal(state) {
      state.extensionModal = false
    },
    extensionsAddition(state, extension) {
      const type = state.extensionType
      const isNew = state.currentExtensionId == null && state.currentExtensionInfo == null

      if (type === 'userExtension') {
        if (isNew) {
          extension.ID = state.userExtensionCount
          if (!state.parentExtension) {
            state.userExtensions.push(extension)
          } else {
            if (!state.parentExtension.complex) {
              state.parentExtension.complex = []
            }
            state.parentExtension.complex.push(extension)
          }
          state.userExtensionCount++
        } else {
          let replacementExtensionInfo = null
          if (!state.parentExtension) {
            replacementExtensionInfo = state.userExtensions.find(obj => obj.ID === state.currentExtensionId)
          } else {
            replacementExtensionInfo = state.parentExtension.complex.find(obj => obj.ID === state.currentExtensionId)
          }
          if (replacementExtensionInfo) {
            Object.assign(replacementExtensionInfo, extension)
          }
          state.currentExtensionInfo = null
          state.currentExtensionId = null
        }
      } else if (type === 'ilmd') {
        if (isNew) {
          extension.ID = state.ilmdCount
          if (!state.parentIlmd) {
            state.ilmd.push(extension)
          } else {
            if (!state.parentIlmd.complex) {
              state.parentIlmd.complex = []
            }
            state.parentIlmd.complex.push(extension)
          }
          state.ilmdCount++
        } else {
          let replacementExtensionInfo = null
          if (!state.parentIlmd) {
            replacementExtensionInfo = state.ilmd.find(obj => obj.ID === state.currentExtensionId)
          } else {
            replacementExtensionInfo = state.parentIlmd.complex.find(obj => obj.ID === state.currentExtensionId)
          }
          if (replacementExtensionInfo) {
            Object.assign(replacementExtensionInfo, extension)
          }
          state.currentExtensionInfo = null
          state.currentExtensionId = null
        }
      } else if (type === 'ErrorExtension') {
        if (isNew) {
          extension.ID = state.errorExtensionCount
          if (!state.errorParentExtension) {
            state.errorExtensions.push(extension)
          } else {
            if (!state.errorParentExtension.complex) {
              state.errorParentExtension.complex = []
            }
            state.errorParentExtension.complex.push(extension)
          }
          state.errorExtensionCount++
        } else {
          let replacementExtensionInfo = null
          if (!state.errorParentExtension) {
            replacementExtensionInfo = state.errorExtensions.find(obj => obj.ID === state.currentExtensionId)
          } else {
            replacementExtensionInfo = state.errorParentExtension.complex.find(obj => obj.ID === state.currentExtensionId)
          }
          if (replacementExtensionInfo) {
            Object.assign(replacementExtensionInfo, extension)
          }
          state.currentExtensionInfo = null
          state.currentExtensionId = null
        }
      }
    },
    setParentExtension(state, extension) {
      if (state.extensionType === 'userExtension') {
        state.parentExtension = extension
      } else if (state.extensionType === 'ilmd') {
        state.parentIlmd = extension
      } else if (state.extensionType === 'ErrorExtension') {
        state.errorParentExtension = extension
      }
    },
    extensionText(state, payload) {
      const { extensionID, text } = payload

      if (state.extensionType === 'userExtension') {
        if (!state.parentExtension) {
          const idx = state.userExtensions.findIndex(obj => obj.ID === extensionID)
          if (idx !== -1) state.userExtensions[idx].text = text
        } else {
          const idx = state.parentExtension.complex.findIndex(obj => obj.ID === extensionID)
          if (idx !== -1) state.parentExtension.complex[idx].text = text
        }
      } else if (state.extensionType === 'ilmd') {
        if (!state.parentIlmd) {
          const idx = state.ilmd.findIndex(obj => obj.ID === extensionID)
          if (idx !== -1) state.ilmd[idx].text = text
        } else {
          const idx = state.parentIlmd.complex.findIndex(obj => obj.ID === extensionID)
          if (idx !== -1) state.parentIlmd.complex[idx].text = text
        }
      } else if (state.extensionType === 'ErrorExtension') {
        if (!state.errorParentExtension) {
          const idx = state.errorExtensions.findIndex(obj => obj.ID === extensionID)
          if (idx !== -1) state.errorExtensions[idx].text = text
        } else {
          const idx = state.errorParentExtension.complex.findIndex(obj => obj.ID === extensionID)
          if (idx !== -1) state.errorParentExtension.complex[idx].text = text
        }
      }
    },
    modifyExtension(state, extensionID) {
      state.currentExtensionId = extensionID
      if (state.extensionType === 'userExtension') {
        if (!state.parentExtension) {
          state.currentExtensionInfo = state.userExtensions.find(obj => obj.ID === extensionID)
        } else {
          state.currentExtensionInfo = state.parentExtension.complex.find(obj => obj.ID === extensionID)
        }
      } else if (state.extensionType === 'ilmd') {
        if (!state.parentIlmd) {
          state.currentExtensionInfo = state.ilmd.find(obj => obj.ID === extensionID)
        } else {
          state.currentExtensionInfo = state.parentIlmd.complex.find(obj => obj.ID === extensionID)
        }
      } else if (state.extensionType === 'ErrorExtension') {
        if (!state.errorParentExtension) {
          state.currentExtensionInfo = state.errorExtensions.find(obj => obj.ID === extensionID)
        } else {
          state.currentExtensionInfo = state.errorParentExtension.complex.find(obj => obj.ID === extensionID)
        }
      }
    },
    deleteExtension(state, extensionID) {
      if (state.extensionType === 'userExtension') {
        if (!state.parentExtension) {
          const idx = state.userExtensions.findIndex(obj => obj.ID === extensionID)
          if (idx !== -1) {
            state.userExtensions.splice(idx, 1)
          }
        } else {
          const idx = state.parentExtension.complex.findIndex(obj => obj.ID === extensionID)
          if (idx !== -1) {
            state.parentExtension.complex.splice(idx, 1)
          }
        }
      }
      if (state.extensionType === 'ilmd') {
        if (!state.parentIlmd) {
          const idx = state.ilmd.findIndex(obj => obj.ID === extensionID)
          if (idx !== -1) {
            state.ilmd.splice(idx, 1)
          }
        } else {
          const idx = state.parentIlmd.complex.findIndex(obj => obj.ID === extensionID)
          if (idx !== -1) {
            state.parentIlmd.complex.splice(idx, 1)
          }
        }
      }
      if (state.extensionType === 'ErrorExtension') {
        if (!state.errorParentExtension) {
          const idx = state.errorExtensions.findIndex(obj => obj.ID === extensionID)
          if (idx !== -1) {
            state.errorExtensions.splice(idx, 1)
          }
        } else {
          const idx = state.errorParentExtension.complex.findIndex(obj => obj.ID === extensionID)
          if (idx !== -1) {
            state.errorParentExtension.complex.splice(idx, 1)
          }
        }
      }
    },
    populateRawData(state, payload) {
      state.userExtensions = Array.isArray(payload.userExtensions) ? payload.userExtensions : []
      state.ilmd = Array.isArray(payload.ilmd) ? payload.ilmd : []
      state.errorExtensions = Array.isArray(payload.errorExtensions) ? payload.errorExtensions : []

      state.userExtensionCount = state.userExtensions.length > 0 ? state.userExtensions.at(-1).ID + 1 : 0
      state.ilmdCount = state.ilmd.length > 0 ? state.ilmd.at(-1).ID + 1 : 0
      state.errorExtensionCount = state.errorExtensions.length > 0 ? state.errorExtensions.at(-1).ID + 1 : 0
    },
    resetCurrentExtensionInfo(state) {
      state.currentExtensionInfo = null
      state.currentExtensionId = null
    }
  },

  actions: {},

  getters: {}
}
